import { formatSeverityLabel, getSeverityBadgeClasses } from "./severityStyles";

const SeverityBadge = ({ severity, className = "", "data-testid": dataTestId }) => {
  return (
    <span
      data-testid={dataTestId}
      className={`inline-flex shrink-0 items-center justify-center rounded border px-1.5 py-0 text-[11px] leading-4 font-medium capitalize min-w-[4rem] w-[4rem] ${getSeverityBadgeClasses(severity)} ${className}`}
    >
      {formatSeverityLabel(severity)}
    </span>
  );
};

export default SeverityBadge;
